import RootRoutes from './root-routes.container';
export default RootRoutes;
